<template>
    <v-data-table
        :headers="headers"
        :items="list"
        dense
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        :server-items-length="length"
        :loading="loading"
    >
        <template v-slot:[`item.name`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.supplier_group.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.name}}
        </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "SupplierGroupList",
    data() {
        return {
            headers: [
                { text: "Supplier", value: "name" }
            ],
            footer: {
                'items-per-page-options': [5, 10, 15]
            },
            perm: permissions
        }
    },
    computed : {
        ...mapGetters({
            list: "purchase/supplierGroup/list/data",
            options: "purchase/supplierGroup/list/options",
            loading: "purchase/supplierGroup/list/loading",
            length: "purchase/supplierGroup/list/length",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/supplierGroup/list/updateOptions"
        }),
        handleClickRow(item){  
            this.$router.push({ name: 'SupplierGroupDisplay', params: { id: item.id}})
        }
    }
}
</script>

<style>

</style>